import styled, { keyframes } from 'styled-components';
import { ModalBody } from '@/common/Modal.styles';

const ANIMATION_DURATION = 280;
export { ANIMATION_DURATION };

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-48px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const slideUp = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to   { opacity: 0; transform: translateY(-48px); }
`;

export const AnimatedOverlay = styled.div<{ $closing: boolean }>`
  align-items: center;
  animation: ${({ $closing }) => ($closing ? fadeOut : fadeIn)}
    ${ANIMATION_DURATION}ms ease forwards;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`;

export const AnimatedModalContent = styled.div<{ $closing: boolean }>`
  animation: ${({ $closing }) => ($closing ? slideUp : slideDown)}
    ${ANIMATION_DURATION}ms ease forwards;
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  max-width: 760px;
  min-height: 232px;
  position: relative;
  width: 90%;
`;

export const RequestModalBody = styled(ModalBody)`
  padding: 17px 15px;
`;

export const IntroHeading = styled.h2`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 16px;
  line-height: 1.7;
  margin: 0 0 20px 0;
`;

export const IntroText = styled.p`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 16px;
  line-height: 1.7;
  margin: 0 0 22px 0;
`;

export const InfoBlocksRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 28px;
`;
